import { render, staticRenderFns } from "./ProyectForm.vue?vue&type=template&id=42b2b3a8&"
import script from "./ProyectForm.vue?vue&type=script&lang=js&"
export * from "./ProyectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports